<template>
  <div>
    <v-card-title class="pa-1 justify-space-between">
      <h3 class="white--text">{{ newField.label }}</h3>
      <v-btn v-if="$store.getters.permissionToWrite" slot="footer" icon @click="newEntity()">
        <v-icon>add_to_photos</v-icon>
      </v-btn>
    </v-card-title>
    <v-tabs v-if="tabs && tabs.length" v-model="tab">
      <div
        v-for="tabItem in tabs"
        :key="`tab_switcher_session_${tabItem.tabKey}`"
        class="width-270"
      >
        <v-tab :href="`#${tabItem.tabKey}`" :class="`${tab === tabItem.tabKey ? 'white--text' : 'grey--text'}`" class="mt-4" style="justify-content: start;">
          <v-icon v-if="tabItem.icon" :class="[{'white--text': tab === tabItem.tabKey},'grey--text']">{{ tabItem.icon }}</v-icon>
          <i v-if="tabItem.customIcon" :class="[`icon ${tabItem.customIcon} ${tab === tabItem.tabKey ? 'white--text' : 'grey--text'}`]"></i>
          <span class="ml-2">
            {{ tabItem.label }}
          </span>
        </v-tab>
      </div>

      <v-tabs-slider color="red" />

      <v-tabs-items v-model="tab" class="no-scroll">
        <v-tab-item
          v-for="tabItem in tabs"
          :key="`tab_content_${tabItem.tabKey}`"
          :value="`${tabItem.tabKey}`"
        >
          <v-container>
            <v-data-table
              :headers="headers"
              :items="tabItem.items"
              :items-per-page="5"
            >
              <template #item.actions="{ item, index }">
                <v-btn
                  class="mr-4"
                  light
                  icon
                  @click="deletePrice(item)"
                >
                  <v-icon color="white">delete</v-icon>
                </v-btn>
                <v-btn
                  class="mr-4"
                  light
                  icon
                  @click="editEntity(item)"
                >
                  <v-icon color="white">edit</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
    <div v-else class="text-center">
      Aucun prix créé
    </div>
    <EntityPopup
      ref="entityPopup"
      :raw-content-types="rawContentTypes"
      :content-type="contentType"
      :update="update"
      :create="create"
    />
  </div>
</template>
<script setup>
import { computed, onMounted, ref, watch, nextTick } from 'vue';
import { useStore } from 'vue2-helpers/vuex';

import EntityPopup from '../Entity/EntityPopup.vue';

import { getContentTypeByConfigArg } from '@/utils/content';

const props = defineProps({
  value: {
    type: Array,
    default: () => {}
  },
  formContent: {
    type: Object,
    default: () => {}
  }, // All states
  field: {
    type: Object,
    default: () => {}
  }
});

const emit = defineEmits(['input']);

const store = useStore();
const rawContentTypes = computed(() => store.state.rawContentTypes);
const contentType = getContentTypeByConfigArg('type', props.field.type, rawContentTypes.value);
const newValue = ref(props.value);
const newField = ref({});
const tab = ref(null);
const headers = ref([
  { text: 'Prix Categorie', value: 'priceCategory' },
  { text: 'tva', value: 'tva' },
  { text: 'Prix', value: 'price' },
  { text: 'Action', value: 'actions' }
]);
const isMounted = ref(false);

onMounted(() => {
  newField.value = { ...props.field, dialog: false };
  isMounted.value = true;
});

const tabs = computed(() => {
  if (props.formContent && props.formContent.prices && props.formContent.prices.length) {
    const periods = {};
    props.formContent.prices.forEach(price => {
      const itemToPush = {
        priceCategory: price.priceCategory?.name || '',
        price: price.price,
        tva: price.tva,
        parent_uuid: price.period.uuid,
        uuid: price.uuid,
        metadata: {
          period: price.period,
          price: price.price,
          priceCategory: price.priceCategory,
          tva: price.tva,
          uuid: price.uuid
        }
      };

      if (!Object.keys(periods).includes(price.period.uuid)) {
        periods[price.period.uuid] = {
          key: price.period.uuid,
          label: price.period?.name || '',
          items: [itemToPush]
        };
        return;
      }

      periods[price.period.uuid].items.push(itemToPush);
    });

    return Object.keys(periods).map(key => {
      const period = periods[key];
      return { tabKey: period.key, label: period.label, items: period.items };
    });
  }
  return [];
});

watch(newValue, val => {
  emit('input', val || null);
}, { deep: true });
watch(props.field, val => {
  newField.value = val;
});
const entityPopup = ref(null);
const editEntity = item => {
  entityPopup.value.editItem(item.metadata);
};

const newEntity = () => {
  entityPopup.value.newItem();
};

const deletePrice = item => {
  const index = newValue.value.findIndex(period => period.period.uuid === item.parent_uuid && period.priceCategory && period.priceCategory?.name === item.priceCategory);

  if (index !== -1) {
    newValue.value.splice(index, 1);
  }
};

// const closeEntityPopup = () => {
//   newField.value.dialog = false;
// };
// const save = (data, index) => {
//   if (index !== null) {
//     const periodIndex = newValue.value.findIndex(period => newField.value.value.uuid === period.uuid);

//     if (periodIndex !== -1) {
//       newValue.value[periodIndex] = data;
//       props.formContent[newField.value.code].splice(periodIndex, 1, newValue.value[periodIndex]);
//     }
//   } else {
//     newValue.value.push(data);
//   }
//   newField.value.dialog = false;
// };

const changed = ref(false);
const forceRenderer = ref(false);
const editItem = ref(null);

const emitNewValue = () => {
  changed.value = true;

  // FORCES RENDER LIST
  forceRenderer.value = true;
  nextTick(() => {
    forceRenderer.value = false;
  });

  // console.log('################### emitNewValue');
  // emit('input', newValue.value);
  emit('input', JSON.parse(JSON.stringify(newValue.value)));
};

const update = value => {
  // If is editing an item
  const index = newValue.value.findIndex(p => p?.period?.uuid === value?.period?.uuid && p?.priceCategory?.uuid === value?.priceCategory?.uuid);

  if (index !== -1) {
    newValue.value[index] = value;
  }

  emitNewValue();
};

const create = value => {
  if (props.field.multivalued) {
    newValue.value = newValue.value || [];
    newValue.value.push(value);
  } else {
    newValue.value = value;
  }

  emitNewValue();
};
</script>
